export const EventBus = new Vue();